import * as React from "react";
import { DismissRegular } from "@fluentui/react-icons";
import {
  MessageBar,
  MessageBarActions,
  MessageBarTitle,
  MessageBarBody,
  Button,
} from "@fluentui/react-components";

/**
 * Interface définissant les propriétés du composant DismissibleMessageBar.
 */
interface DismissibleMessageBarProps {
  title: string; // Titre du message
  message: string; // Contenu du message
}

/**
 * Composant DismissibleMessageBar qui affiche un message avec un bouton de fermeture.
 * @param {DismissibleMessageBarProps} props - Propriétés du composant.
 * @returns {JSX.Element | null} - Le composant MessageBar ou null si le message est masqué.
 */
const DismissibleMessageBar: React.FC<DismissibleMessageBarProps> = ({ title, message }) => {
  // État local pour gérer la visibilité de la barre de message
  const [visible, setVisible] = React.useState(true);

  // Si la barre de message n'est pas visible, ne rien afficher
  if (!visible) return null;

  return (
    <MessageBar>
      {/* Corps de la barre de message */}
      <MessageBarBody>
        <MessageBarTitle>{title}</MessageBarTitle>
        {message}
      </MessageBarBody>

      {/* Actions de la barre de message */}
      <MessageBarActions
        containerAction={
          <Button
            aria-label="dismiss"
            appearance="transparent"
            icon={<DismissRegular />}
            onClick={() => setVisible(false)}
          />
        }
      ></MessageBarActions>
    </MessageBar>
  );
};

/**
 * Composant MessageIA : affiche un message d'avertissement concernant les messages générés par l'IA.
 */
export const MessageIA = () => (
  <DismissibleMessageBar
    title="Avertissement :"
    message="Les messages générés par l'IA peuvent contenir des erreurs ou des inexactitudes."
  />
);
